<template>
  <b-modal
    :hide-footer="true"
    centered
    scrollable
    size="xl"
    :id="visible"
    @hidden="$bvModal.hide(visible)"
  >
    <template #modal-title>
      <strong class="font-size-19">
        Agenda - {{ tecnico }}
      </strong>
    </template>
    <div class="row">
      <div class="col-md-12">
        <print-content>
          <div class="d-flex align-items-center justify-content-center mb-2">
            <strong class="font-size-22">
              Agenda - {{ dataAtendimento }}
            </strong>
          </div>
          <table
            class="table b-table b-table-stacked-xs table-bordered table-sm bg-white mb-0"
          >
            <tbody>
              <tr>
                <td colspan="3" class="pt-2 pb-2">
                  Técnico: <strong> {{ tecnico }} </strong>
                </td>
              </tr>
              <tr>
                <td colspan="3" class="pt-2 pb-2">
                  Unidade: <strong> {{ unidade }} </strong>
                </td>
              </tr>
              <tr>
                <td colspan="3" class="pt-2 pb-2">
                  Expediente: <strong> {{ expediente }} </strong>
                </td>
              </tr>
              <template v-if="agenda?.periodo">
                <tr>
                  <td style="padding-top: 10px; padding-bottom: 10px;">
                    <strong class="d-flex align-items-center flex-wrap" style="column-gap: 5px">
                      {{ agenda?.periodo?.descricao }}
                      ({{ agenda?.periodo?.dia | formatDate() }}
                      à
                      {{ agenda?.periodo?.dia_fim | formatDate() }})
                    </strong>
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr v-for="(item, idx) in agenda?.agenda" :key="idx">
                  <td style="white-space: nowrap; width: 1%">
                    <strong> {{ item.horario }} </strong>
                  </td>
                  <td>
                    <div class="d-flex flex-column">
                      <strong> {{ item?.atendimento?.usuarios.map(it => it?.nome).join(', ') }} </strong>
                      <strong v-if="item?.atendimento">
                        {{ item?.atendimento?.descricao }}
                      </strong>

                      <strong
                        :style="getTextStatusStyle(item)"
                        v-if="!item.atendimento || (item?.atendimento && item?.status?.value === 'REAGENDADO')"
                      >
                        {{ item?.descricao }}
                      </strong>
                    </div>
                  </td>
                  <td style="white-space: nowrap; width: 1%;">
                    <strong :style="{ color: item?.status?.cor }">
                      {{ item?.status?.value }}
                    </strong>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </print-content>
      </div>
    </div>
    <section class="d-flex flex-row justify-content-end">
      <b-button
        :title="$t('Imprimir')"
        type="button"
        class="m-0"
        style="padding: 7px 15px"
        v-b-tooltip.hover
        variant="primary"
        @click="print()"
      >
        <i class="fas fa-light fa-print"></i>
      </b-button>
    </section>
  </b-modal>
</template>

<script>
export default {
  name: "AgendaTecnicoImpressaoModal",
  props: [
    "dataAtendimento",
    "tecnico",
    "unidade",
    "expediente",
    "agenda",
    "visible",
    "getTextStatusStyle"
  ],
}
</script>
